const translationCatalog = {
  en: {
    translation: {
      'welcome to': 'welcome to',
      'What type of visitor are you?': 'What type of visitor are you?',
      Yes: 'Yes',
    },
  },
  fr: {
    translation: {
      'welcome to': 'Bienvenue sur',
      'WELCOME TO': 'Bienvenue sur',
      'What type of visitor are you?': 'Quel type de visiteur êtes-vous ?',
      visitor: 'visiteur',
      contractor: 'contractant',
      delivery: 'livraison',
      employee: 'employé',
      member: 'membre',
      courier: 'courrier',
      'a returning visitor': 'un visiteur qui revient',
      Loading: 'Chargement',
      'Tell us about yourself': 'Parlez-nous de vous',
      Name: 'Nom',
      Company: 'Société',
      PREV: 'Précédent',
      NEXT: 'Suivant',
      'Name of host': "Nom de l'hôte",
      'Type and select the host name': "Tapez et sélectionnez le nom de l'hôte",
      'Who are you visiting': 'Qui visitez-vous',
      'We did not find the name of the person you’re looking for, please enter a valid name':
        "Nous n'avons pas trouvé le nom de la personne que vous recherchez, veuillez saisir un nom valide",
      Questionnaire: 'Questionnaire',
      'Please answer the questionnaire below': 'Veuillez répondre au questionnaire ci-dessous',
      'My name is': 'Mon nom est',
      'I am from': 'Je suis de',
      'I am': 'Je suis',
      Mobile: 'Mobile',
      'Are you visiting': 'Vous êtes en visite',
      Yes: 'Oui',
      No: 'Non',
      Submitting: 'Soumettre',
      'Enter your name': 'Entrez votre nom',
      'Enter Name': 'Entrez le nom',
      'Sign in failed!': 'La connexion a échoué!',
      'Your submission is not compliant with our health and safety policy.': "Votre soumission n'est pas conforme à notre politique de santé et de sécurité.",
      'Please stay where you are, Management will be contacting you momentarily.': 'Veuillez rester où vous êtes, la direction vous contactera dans un instant',
    },
  },
  sp: {
    translation: {
      'welcome to': 'Bienvenido a',
      'WELCOME TO': 'Bienvenido a',
      'What type of visitor are you?': 'Que tipo de visitante es usted?',
      visitor: 'visitante',
      contractor: 'contratista',
      delivery: 'entrega',
      employee: 'empleado',
      member: 'miembro',
      courier: 'mensajero',
      'a returning visitor': 'visitante que regrega',
      Loading: 'Cargando',
      'Tell us about yourself': 'Cuéntanos acerca de usted',
      Name: 'Nombre',
      Company: 'Compañía',
      PREV: 'Anterior',
      NEXT: 'Siguiente',
      'Name of host': 'Nombre de anfitrión',
      'Type and select the host name': 'Escriba y seleccione el nombre del anfitrión',
      'Who are you visiting': 'A quien esta visitando',
      'We did not find the name of the person you’re looking for, please enter a valid name':
        'No encontramos el nombre de la persona que está buscando, ingrese un nombre válido',
      Questionnaire: 'Cuestionario',
      'Please answer the questionnaire below': 'Responda el cuestionario a continuación',
      'My name is': 'Mi nombre es',
      'I am from': 'Soy de',
      'I am': 'Yo soy',
      Mobile: 'móvil',
      'Are you visiting': 'Esta usded visitando',
      Yes: 'Sí',
      No: 'No',
      Submitting: 'Enviando',
      'Enter your name': 'Introduzca su nombre',
      'Enter Name': 'Igrese su nombre',
      'Sign in failed!': '¡Fallo al iniciar sesion!',
      'Your submission is not compliant with our health and safety policy.': 'Su envio no cumple con nuestra política de salud y segurida',
      'Please stay where you are, Management will be contacting you momentarily.': 'Por favor, quédese donde está, la gerencia se comunicará con usted momentáneamente',
    },
  },
  ru: {
    translation: {
      'What type of visitor are you?': 'Хто ты?',
      Yes: 'Да',
    },
  },
};

export default translationCatalog;
